export const setUnvisitedPlacesFailed = ({ reason }) => state => {
  return {
    ...state,
    unvisitedPlaces: {
      ...state.unvisitedPlaces,
      lastFetch: {
        failed: true,
        lastFailure: Date.now(),
        reason,
      },
      loadingUnvisitedPlaces: false,
    },
  };
};
